import { Grid, Typography, withStyles } from '@material-ui/core';
// import IconButton from '@material-ui/core/IconButton';
// import { PlayCircleOutlineOutlined } from '@material-ui/icons';
import React, { useState } from 'react';
import { VideoPlayer } from './VideoPlayer';

// use of React.hooks to avoid passing the lifecycle from outside
const ModuleVideo = ({ classes, name, videoUrl }) => {
  const [openVideo, setOpen] = useState(false);

  // function handleClickOpen() {
  //   setOpen(true);
  // }

  function handleClose() {
    setOpen(false);
  }

  return (
    <Grid container alignItems={'center'}>
      <Grid item xs={10} md={6} className={classes.clipTitleItem}>
        <Typography variant={'body1'}>{name}</Typography>
      </Grid>

      {/*{videoUrl && (
        <Grid item xs={2} md={2}>
          <IconButton onClick={handleClickOpen}>
            <PlayCircleOutlineOutlined color={'primary'} />
          </IconButton>
        </Grid>
      )}*/}

      {openVideo && <VideoPlayer classes={classes} videoUrl={videoUrl} open={openVideo} handleClose={handleClose} />}
    </Grid>
  );
};

const styles = theme => ({
  clipTitleItem: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  videoPlayer: {
    height: 400,
    width: 600,
    [theme.breakpoints.down('md')]: {
      height: 200,
      width: 300,

    }
  }
});

export default withStyles(styles)(ModuleVideo);
